import { PaginationState } from "@tanstack/react-table"
import { Dispatch, SetStateAction } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"
import { GetEcobalyseMaterialTypesResponseDto } from "@tfg/types/schemas/modules/lifeCycleAnalysis/dtos/get-ecobalyse-material-types.response.dto"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { MaterialTypesResponseDto } from "~/gen/api"

import { useColumns } from "./columns"

type Props = {
  materialTypes: MaterialTypesResponseDto[]
  materialOpChains: AdminResponses.OperationChainElement[]
  ecobalyseMaterialTypes: GetEcobalyseMaterialTypesResponseDto
  total: number
  pagination: PaginationState
  setPagination: Dispatch<SetStateAction<PaginationState>>
}

export function MaterialTypesTable({
  materialTypes,
  materialOpChains,
  ecobalyseMaterialTypes,
  total,
  pagination,
  setPagination,
}: Props) {
  const columns = useColumns(materialOpChains, ecobalyseMaterialTypes)

  const table = useCustomReactTable({
    data: materialTypes,
    columns,
    state: {
      pagination,
    },
    pageCount: Math.ceil(total / pagination.pageSize),
    manualPagination: true,
    onPaginationChange: setPagination,
  })

  return <CustomTable table={table} manualPaginationCount={total} />
}
